var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isAlertActive &&
    _vm.getAlertByType(_vm.alertType) &&
    _vm.getAlertByType(_vm.alertType)["extra"]["message"]
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "alert text-center rounded-0",
            class: "alert-" + _vm.alertColor,
          },
          [
            _vm._v(
              _vm._s(_vm.getAlertByType(_vm.alertType)["extra"]["message"])
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }